module.exports = __webpack_public_path__ + "img/tassei_new.c0cd025c.png";